import { DynamicSizedLoadingRow } from 'components/Loader/styled'
import { MouseoverTooltip } from 'components/Tooltip'
import { IslandApiResponse } from 'state/data/slice'
import { useTheme } from 'styled-components'
import { ThemedText } from 'theme'
import { formatDollarAmount } from 'utils/formatDollarAmt'

import * as S from './styled'

const LoadingSkeleton = () => (
  <DynamicSizedLoadingRow
    style={{ width: '50%' }}
    height="24px"
    borderRadius="4px"
    borderTopLeftRadius="0"
    borderTopRightRadius="0"
    borderBottomLeftRadius="0"
    borderBottomRightRadius="0"
  >
    <div />
  </DynamicSizedLoadingRow>
)

interface BalanceData {
  walletBalanceUSD: number
  rewardVaultUSD: number
  farmBalanceUSD: number
  baultBalanceUSD: number
  externalBalanceUSD: number
  totalBalanceUSD: number
  isRewardVault: boolean
}

const UserBalanceContent = ({ balanceData }: { balanceData: BalanceData }) => {
  const theme = useTheme()

  const hasBreakdown =
    balanceData.walletBalanceUSD > 0 ||
    balanceData.farmBalanceUSD > 0 ||
    balanceData.rewardVaultUSD > 0 ||
    balanceData.baultBalanceUSD > 0 ||
    balanceData.externalBalanceUSD > 0

  const tooltipContent = (
    <ThemedText.DeprecatedBody fontSize="12px" fontWeight="500" lineHeight="20px" color={theme.textPrimary}>
      {balanceData.walletBalanceUSD > 0 && <div>{`Wallet: ${formatDollarAmount(balanceData.walletBalanceUSD)}`}</div>}
      {balanceData.rewardVaultUSD > 0 && <div>{`Reward Vault: ${formatDollarAmount(balanceData.rewardVaultUSD)}`}</div>}
      {balanceData.farmBalanceUSD > 0 && <div>{`Farm: ${formatDollarAmount(balanceData.farmBalanceUSD)}`}</div>}
      {balanceData.baultBalanceUSD > 0 && <div>{`Bault: ${formatDollarAmount(balanceData.baultBalanceUSD)}`}</div>}
      {balanceData.externalBalanceUSD > 0 && (
        <div>{`External: ${formatDollarAmount(balanceData.externalBalanceUSD)}`}</div>
      )}
    </ThemedText.DeprecatedBody>
  )

  if (hasBreakdown) {
    return (
      <MouseoverTooltip text={tooltipContent}>
        <ThemedText.DeprecatedBody fontSize="14px" fontWeight="400" lineHeight="24px" color={theme.textSecondary}>
          {formatDollarAmount(balanceData.totalBalanceUSD)}
        </ThemedText.DeprecatedBody>
      </MouseoverTooltip>
    )
  }

  return (
    <ThemedText.DeprecatedBody fontSize="14px" fontWeight="400" lineHeight="24px" color={theme.textSecondary}>
      {formatDollarAmount(balanceData.totalBalanceUSD)}
    </ThemedText.DeprecatedBody>
  )
}

export default function UserBalanceColumn({ island }: { island: IslandApiResponse }) {
  const balanceData: BalanceData = {
    walletBalanceUSD: island.vaultBalanceUSD || 0,
    rewardVaultUSD: island.farm?.provider === 'bgt' ? island.farmBalanceUSD : 0,
    farmBalanceUSD: island.farm?.provider === 'kodiak' ? island.farmBalanceUSD : 0 || 0,
    baultBalanceUSD: island.baultBalanceUSD || 0,
    externalBalanceUSD: island.externalBalanceUSD || 0,
    totalBalanceUSD: island.balanceUSD || 0,
    isRewardVault: island.isRewardVault,
  }

  return (
    <S.RangeLineItem>
      <UserBalanceContent balanceData={balanceData} />
    </S.RangeLineItem>
  )
}
